import { urlString } from "./common-utils";

const STACK_KEY = "navStack";

export const ROUTES = {
  HOME: `${urlString}/home`,
  SYLLABUS: `${urlString}/syllabus`,
  REVIEW: `${urlString}/review`,
  PRACTICE: `${urlString}/practice`,
  ASSESSMENT: `${urlString}/assessment`,
};

export function getNavStack() {
  const stack = sessionStorage.getItem(STACK_KEY);
  return stack ? JSON.parse(stack) : [];
}

export function setNavStack(stack) {
  sessionStorage.setItem(STACK_KEY, JSON.stringify(stack));
}

export function pushRouteToStack(route) {
  const stack = getNavStack();
  // adding route to stack
  stack.unshift(route);
  setNavStack(stack);
}

export function clearStackAndPush(route) {
  setNavStack([route]);
}

export function getTopNonExecutionRoute() {
  const stack = getNavStack();
  return stack.find((r) => [ROUTES.HOME, ROUTES.SYLLABUS].includes(r));
}

export function isReviewAboveHomeOrSyllabus() {
  const stack = getNavStack();
  const reviewIndex = stack.indexOf(ROUTES.REVIEW);
  const homeIndex = stack.indexOf(ROUTES.HOME);
  const syllabusIndex = stack.indexOf(ROUTES.SYLLABUS);
  return (
    reviewIndex !== -1 &&
    (homeIndex === -1 || reviewIndex < homeIndex) &&
    (syllabusIndex === -1 || reviewIndex < syllabusIndex)
  );
}

export function isExecutionRoute(route) {
  return [ROUTES.PRACTICE, ROUTES.ASSESSMENT].includes(route);
}

export function isRestrictedRoute(route) {
  return [ROUTES.HOME].includes(route);
}
